<template>
  <div class="material">
    <el-row type="flex">
      <el-col class="table-th" :span="4">活动明细名称</el-col>
      <el-col :span="20">
        <el-row type="flex">
          <el-col class="table-th" :span="4">要求核销资料</el-col>
          <el-col class="table-th" :span="7">描述</el-col>
          <el-col class="table-th" :span="6">示例</el-col>
          <el-col class="table-th" :span="7">上传</el-col>
        </el-row>
      </el-col>
    </el-row>
    <template v-for="(item, k) in list">
      <el-row :key="k" type="flex" v-if="item.auditRequires.length > 0">
        <el-col class="table-td" :span="4">{{ item.fineName }}</el-col>
        <el-col :span="20">
          <el-row v-for="(subItem, j) in item.auditRequires" :key="j" type="flex">
            <el-col class="table-td" :span="4">{{ subItem.exampleName }}</el-col>
            <el-col class="table-td" :span="7">{{ subItem.remarks }}</el-col>
            <el-col class="table-td" :span="6">
              <div>
                <el-image
                  style="max-width: 80px;"
                  :src="getImgUrls(subItem.pictureRespVos)[0]"
                  :preview-src-list="getImgUrls(subItem.pictureRespVos)"
                ></el-image>
              </div>
            </el-col>
            <el-col class="table-td" :span="7">
              <Upload
                style="width: 100%"
                :disabled="formConfig.disabled"
                :astrictState="astrictState"
                fileMsg
                clearable
                v-model="subItem.auditFileReqVos"
                @getFileList="v => getFileList(v, k, j)"
                >上传</Upload
              >
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </template>
  </div>
</template>

<script>
import request from '../../../../../../../utils/request';
import Upload from '../../../../../../../modules/upload/upload.vue';

export default {
  name: 'material',
  props: {
    formConfig: Object,
    getFieldValue: Function,
  },
  data() {
    return {
      list: [],
      astrictState: false,
    };
  },
  components: {
    Upload,
  },
  async mounted() {
    const res = await request.post('/tpm/tpmAuditController/costTypeFineListByFineCode', {
      ...this.formConfig.row,
    });
    if (res.success) {
      this.list = res.result.map((item) => {
        const v = { ...item };
        v.auditRequires = v.auditRequires
          ? v.auditRequires.map((subItem) => ({
            ...subItem,
            auditFileReqVos: subItem.auditFileReqVos
              ? subItem.auditFileReqVos.map((subChild) => ({
                ...subChild,
                url: subChild.addressUrl,
                fileName: subChild.auditRequireNames,
              }))
              : [],
          }))
          : [];
        return v;
      });
    }
  },
  methods: {
    // 示例图片地址
    getImgUrls(data) {
      let list = [];

      if (data) {
        list = data.map((v) => v.urlAddress);
      }

      return list;
    },
    // 获取资料列表
    getFileList(val, k, j) {
      const _list = val.map((item) => {
        const v = item;
        return {
          ...v,
          auditFileType: 1,
          fineCode: this.list[k].fineCode,
          addressUrl: v.url,
          auditRequireNames: v.fileName,
          exampleCode: this.list[k].auditRequires[j].exampleCode,
        };
      });

      this.list[k].auditRequires[j].auditFileReqVos = _list;

      let means = [];
      this.list.forEach((v) => {
        v.auditRequires.forEach((sub) => {
          means = means.concat(sub.auditFileReqVos || []);
        });
      });

      this.$emit(
        'setFielValue',
        means.filter((v) => v),
      );
    },
  },
};
</script>

<style lang="less" scoped>
.material {
  border-top: 1px solid #dcdfe6;
  border-left: 1px solid #dcdfe6;
  margin-bottom: 20px;
  .table-th {
    word-break: break-all;
    padding: 6px 10px;
    background-color: #f8f8f9;
    border-right: 1px solid #dcdfe6;
    border-bottom: 1px solid #dcdfe6;
    height: 36px;
    line-height: 24px;
    font-size: 12px;
    font-weight: 700;
    color: #606266;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .table-td {
    align-items: center;
    display: flex;
    border-right: 1px solid #dcdfe6;
    border-bottom: 1px solid #dcdfe6;
    min-height: 36px;
    word-break: break-all;
    padding: 6px 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
